var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactLinkedin50X50(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50ZM16.0657 15.8027C17.4928 15.8027 18.649 14.6332 18.649 13.1898C18.649 11.7475 17.4928 10.5769 16.0657 10.5769C14.6386 10.5769 13.4824 11.7475 13.4824 13.1898C13.4824 14.6332 14.6386 15.8027 16.0657 15.8027ZM13.4615 34.6154V17.893H18.6699V34.6154H13.4615ZM21.8095 17.893H26.9845V20.1453C29.1678 16.0911 38.4615 15.7912 38.4615 24.027V34.6154H33.2657V25.8372C33.2657 20.5571 26.9855 20.9563 26.9855 25.8372V34.6154H21.8095V17.893Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLinkedin50X50);
export default __webpack_public_path__ + "static/media/contact-linkedin-50x50.8203ccf5.svg";
export { ForwardRef as ReactComponent };